import React, { useRef } from 'react';
import { TEMPLATE_VARIABLES, renderMessageTemplate, PREVIEW_TEMPLATE_CONTEXT } from '../../utils/messageTemplate';

const TemplateVariablesField = ({
  label,
  value,
  onChange,
  rows = 4,
  placeholder,
  previewContext = PREVIEW_TEMPLATE_CONTEXT,
}) => {
  const textareaRef = useRef(null);

  const insertVariable = (key) => {
    const el = textareaRef.current;
    const start = el?.selectionStart ?? value.length;
    const end = el?.selectionEnd ?? start;
    const tag = `{{${key}}}`;
    const next = value.slice(0, start) + tag + value.slice(end);
    onChange(next);
    requestAnimationFrame(() => {
      if (!el) return;
      el.focus();
      const pos = start + tag.length;
      el.setSelectionRange(pos, pos);
    });
  };

  const hasVariables = /\{\{[^}]+\}\}/.test(value || '');
  const preview = hasVariables ? renderMessageTemplate(value, previewContext) : '';

  return (
    <div className="admin-template-vars-field">
      <label className="admin-field">
        <span>{label}</span>
        <textarea
          ref={textareaRef}
          rows={rows}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </label>
      <div className="admin-template-vars">
        <span className="admin-hint admin-hint-inline">Вставить поле клиента:</span>
        <div className="admin-day-chips admin-template-var-chips">
          {TEMPLATE_VARIABLES.map((v) => (
            <button
              key={v.key}
              type="button"
              className="admin-day-chip admin-template-var-chip"
              onClick={() => insertVariable(v.key)}
              title={`{{${v.key}}}`}
            >
              {v.label}
            </button>
          ))}
        </div>
        <p className="admin-hint admin-hint-inline">
          Формат: <code>{'{{имя}}'}</code>, <code>{'{{баланс}}'}</code>, <code>{'{{последние_покупки}}'}</code> — подставятся данные владельца карты
        </p>
        {preview && (
          <div className="admin-template-preview-text">
            <span className="admin-hint">Пример для клиента:</span>
            <pre>{preview}</pre>
          </div>
        )}
      </div>
    </div>
  );
};

export default TemplateVariablesField;
